export const SITE_NAME = "SNOMED CT";
